<template>
    <div>
        <!-- InfoPOPUP -->
        <v-layout  row justify-center>
            <v-dialog v-model="mustShowBrowsersListPopup" persistent max-width="600" id="close-popup">
                <v-card class="no-padding not-allGenQAnsw-popup info-popup browsers-list-popup">
                    <v-card-title class="headline bg-color-primary" >
                        <span class="font-weight-regular warn popup-title color-on-primary-text">{{text('api.browser.list.popup.title')}}</span>
                        <span  @click="closeBrowsersListPopup()" class="close-icon">
                            <close-icon/>
                        </span>
                    </v-card-title>
                    <v-card-text class="padding-s elevation-bg-color">

                        <div v-for="(browser, key) in getVerifiedBrowsers.browsers">
                           <h4 class="color-headings-text">{{browser.browser}}</h4>
                            <ul class="browsers-list">
                                <li v-for="version in getVersions(browser)">
                                    {{version}}
                                </li>
                            </ul>
                        </div>

                    </v-card-text>
                    <v-card-actions class="elevation-bg-color">
                        <v-spacer></v-spacer>
                        <v-btn flat @click="closeBrowsersListPopup()" class="cancel">{{text('api.button.close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import CloseIcon from "../svg/shared/closeIcon";

export default {
        name: 'BrowsersListPopup',
    components: {CloseIcon},
    computed: {
            ...mapGetters({
                mustShowBrowsersListPopup: 'TranslationStore/getMustShowBrowsersListPopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getVerifiedBrowsers: 'TranslationStore/getVerifiedBrowsers'
            })
        },

        methods: {

            closeBrowsersListPopup() {
                this.$store.commit('TranslationStore/setMustShowBrowsersListPopup', false);
            },

            getVersions(browser) {

                let allVersions = [];
                for (let i = 0; i < browser.versions.length; i++) {
                    if (browser.versions[i].text !== null) {
                        allVersions.push(browser.versions[i].text)
                    }
                    else {
                        allVersions.push(...browser.versions[i].version);
                    }
                }
                return allVersions;
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/shared/BrowsersListPopup.vue